'use client';

import { c as _c } from "react/compiler-runtime";
import { NavigationMenu } from '@base-ui/react/navigation-menu';
import { type ReactNode } from 'react';
import type { PrimaryNavigationItem } from '../../../../types';
import { NavigationItemLabel } from './navigation-item-label';
import { NavigationItemTrigger } from './navigation-item-trigger';
type NavigationItemProps = {
  children?: ReactNode;
  item: PrimaryNavigationItem;
  onKeyboardClose: () => void;
};
export function NavigationItem(t0) {
  const $ = _c(15);
  const {
    children,
    item,
    onKeyboardClose
  } = t0;
  if (item.kind === "link") {
    let t1;
    if ($[0] !== item.emphasis || $[1] !== item.href || $[2] !== item.openInNewTab || $[3] !== item.title) {
      t1 = <NavigationItemLabel emphasis={item.emphasis} href={item.href} openInNewTab={item.openInNewTab} title={item.title} />;
      $[0] = item.emphasis;
      $[1] = item.href;
      $[2] = item.openInNewTab;
      $[3] = item.title;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    let t2;
    if ($[5] !== item.id || $[6] !== t1) {
      t2 = <NavigationMenu.Item value={item.id} className="desktop-menu__item">{t1}</NavigationMenu.Item>;
      $[5] = item.id;
      $[6] = t1;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  let t1;
  if ($[8] !== item || $[9] !== onKeyboardClose) {
    t1 = <NavigationMenu.Trigger nativeButton={false} render={(props, state) => <NavigationItemTrigger item={item} onKeyboardClose={onKeyboardClose} triggerProps={props} triggerState={state} />} />;
    $[8] = item;
    $[9] = onKeyboardClose;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== children || $[12] !== item.id || $[13] !== t1) {
    t2 = <NavigationMenu.Item value={item.id} className="desktop-menu__item">{t1}{children}</NavigationMenu.Item>;
    $[11] = children;
    $[12] = item.id;
    $[13] = t1;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
}